'use strict';
import angular from 'angular';
import './scripts/scheduledJobs.ctrls';
import './scripts/scheduledJobs.services';

import scheduledJobGroupsHtmlUrl from './views/scheduledJobGroups.html';

angular.module('scheduledJobs', ['scheduledJobs.ctrls', 'scheduleJobs.services'])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('scheduledJobs', {
                parent: 'layout',
                url: '/admin/scheduled/jobGroups',
                templateUrl: scheduledJobGroupsHtmlUrl,
                controller: 'ScheduledJobGroupsController'
            })
    }]);